export interface IMPallet {
  height: number,
  amountOfCakes: number,
  //amountOfPackages: number,
  amountOfLayers: number,
  amountOfPackagesPerLayer: number
}
